var render, staticRenderFns
import script from "./myTake.vue?vue&type=script&lang=js&"
export * from "./myTake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6562a259",
  null
  
)

export default component.exports